module.exports = __webpack_public_path__ + "img/Flag_of_Belarus.e0ce0555.svg";